module.exports = {"532922101":"苍山西镇","532922102":"漾江镇","532922103":"平坡镇","532922104":"顺濞镇","532922201":"富恒乡","532922202":"太平乡","532922204":"瓦厂乡","532922205":"龙潭乡","532922206":"鸡街乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532922.json
// module id = 2785
// module chunks = 0